import {useNavigate} from 'react-router-dom';
import {Button, ErrorPlaceholder, TinctLogo} from '@tinct/web-components';

/**
 * A signed-in person who belongs to no workspace any more (removed, suspended, their last workspace
 * deleted). The layout, and its user menu, only exist inside a workspace: without this page they
 * had a blank screen and no way to sign out.
 */
export const NoWorkspacePage = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen">
      <ErrorPlaceholder
        image={<TinctLogo />}
        title="You don't have access to any workspace"
        description="You may have been removed or suspended from your workspace. Ask one of its admins to invite you again, or sign in with another account."
        actions={
          <Button size="sm" onClick={() => navigate('/logout')}>
            Sign out
          </Button>
        }
      />
    </div>
  );
};
